/** Permission constants, mirroring app.tenants.rbac.Permission. */
export const Permission = {
  SITE_VIEW: 'site:view',
  SITE_CREATE: 'site:create',
  SITE_UPDATE: 'site:update',
  SITE_DELETE: 'site:delete',
  CRAWL_RUN: 'crawl:run',
  AUDIT_RUN: 'audit:run',
  ISSUE_UPDATE: 'issue:update',
  ACTION_VIEW: 'action:view',
  ACTION_CREATE: 'action:create',
  ACTION_EDIT: 'action:edit',
  ACTION_APPROVE: 'action:approve',
  ACTION_EXECUTE: 'action:execute',
  ACTION_ROLLBACK: 'action:rollback',
  INTEGRATION_MANAGE: 'integration:manage',
  ORG_MANAGE_MEMBERS: 'org:manage_members',
} as const;
